module.exports = __webpack_public_path__ + "img/products_5.cdec7108.png";